import React, {useState} from "react";
//import { Link } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Breadcrumb from 'layouts/admin/Breadcrumb';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import UI from "components/UI";
import { useHistory }  from 'react-router-dom';
import UISelect from 'components/selectbox/UISelect';
import UIUtils from "utils/UIUtils";
import CommonUtil from 'utils/CommonUtil';
import message from "common/message/source/MessageSource";
import ModalPopup from "components/modal";
function ContentsContainer() {
	const history = useHistory();
	const [PAY_CALL_CONT,setPAY_CALL_CONT] = useState('');
	const [PAY_CALL_YYYY, setPAY_CALL_YYYY] = useState('');
	const [PAY_CALL_TITLE, setPAY_CALL_TITLE] = useState('');
    const [uploadId, setUploadId] = React.useState("");
    const [fileInfoUploadList, setFileInfoUploadList] = React.useState<any[]>([]);  //파일업로드 리스트
	const [formCheck,setFormCheck] = useState(false);  
	const [modalIsOpen, setmodalIsOpen] = useState(false);
		    	
    async function onClickList() {
	    let dataToSend = {};
	    // 다른 페이지로 이동하면서 데이터 전달
	    history.push({
	      pathname: './adm1400',
	      state: { data: dataToSend }
	    });

    };    
    	
    // 파일업로드 컴포넌트가 로딩된 후 이벤트 처리
    const onCreationComplete = function (uploadID: string) {
        setUploadId(uploadID);
    }

    // 파일업로드가 완료된 후 이벤트 처리
    const onUploadComplete = function (uploadID: string) {
        const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
        const arrayNew = dataArray.newFile;
       // const arrayDel = dataArray.deleteFile;
	
		let fileInfos : {
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
		}[] = [];

		let fileInfo : {
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
		};

		//파일등록 정보
		arrayNew?.forEach((item, index) => {
			if(item.status ==="complete"){
				fileInfo = {
					ORGINL_FILE_NM:item.originalName,
					STRE_FILE_NM:item.uploadName,
					FILE_SIZE:item.size,
					STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
					FILE_EXTSN:item.extension,
				}

				fileInfos.push(fileInfo);
			}
		})

		console.log("fileInfos : "+JSON.stringify(fileInfos));
		setFileInfoUploadList(fileInfos);
    }

    // 등록 버튼 이벤트 처리
    async function onClickSave(sendParam:any) {
        const response:any = await CommonUtil.execute({
            url:"adm_1401_c001",
            data: sendParam
        })
		.then((response: any) => {
			UIUtils.alert(message.get("common.message.save.success", "저장되었습니다."));
            // @ts-ignore
            onClickList();
		}).catch((error) => {
	    	CommonUtil.showAxiosError(error);
	    	return;
       	});	  
	       	
    }
    
	async function PayCallFormCheck() {
		if (PAY_CALL_YYYY === '' || PAY_CALL_TITLE === '' || PAY_CALL_CONT === '') {
			setmodalIsOpen(true);
			//UIUtils.alert('필수 입력이 완료되지 않았습니다. 다시 확인해 주세요.').then();
			return;
		} 
		
		if(await UIUtils.confirm(message.get("common.message.save.confirm", "저장하시겠습니까?"))){
			setFormCheck(true);

			//파일업로드 
			onFileUpload();
		}
	}
	
	const onFileUpload = () => {
		if(uploadId){
			window["RAONKUPLOAD"].Transfer(uploadId);
		}
	}
	
	async function onClose() {
		setmodalIsOpen(false);
		
	}	        
	
		
	React.useEffect(() => {
		if(fileInfoUploadList && formCheck) {
			// 파일 업로드 성공
			let param ={
				"BIZ_CD" : "001",
				"PAY_CALL_YYYY" : PAY_CALL_YYYY,	
				"PAY_CALL_TITLE" : PAY_CALL_TITLE,
				"PAY_CALL_CONT" : PAY_CALL_CONT,
				"RET_CNT" : "0",
				"FILE_ID": uploadId,
				"FILE_INFO_LIST":fileInfoUploadList
	
			}
			
			console.log("param : "+JSON.stringify(param));
			
			//환수정보 저장 
			onClickSave(param);

		}
	}, [fileInfoUploadList])
 	
	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={0} lnbD1Idx={3}  lnbD2Idx={1}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">지급 신청 안내 등록</h1>
					<form className="fo fo-col4" name="" action="" method="">
						<div className="inner">
							<div className="fo-item req">
								<p className="fo-key">지급신청안내년도</p>
								<div className="fo-value">
									<div className="sl sl-md w100p">
										<UISelect
								        	className=""
								        	firstName={"sel"}
								        	value={PAY_CALL_YYYY}
								        	valueChanged={(value) => setPAY_CALL_YYYY(value)}
								        	codeData={[
												{ code: '2020', name: '2020' },
												{ code: '2021', name: '2021' },
												{ code: '2022', name: '2022' },
												{ code: '2023', name: '2023' },
												{ code: '2024', name: '2024' },
												{ code: '2025', name: '2025' },
												{ code: '2026', name: '2026' },
												{ code: '2027', name: '2027' },
												{ code: '2028', name: '2028' },
												{ code: '2029', name: '2029' },
												{ code: '2030', name: '2030' },
											]}
								      	/>
									</div>	
								</div>
							</div>
							<div className="fo-item fo-m-2-5 req">
								<p className="fo-key">제목</p>
								<div className="fo-value">
									<UIInput
										className={'tf tf-md w100p'}
										value={PAY_CALL_TITLE}
										placeholder={'제목을 입력하세요'}
										readOnly={false}
										valueChanged={(value) => setPAY_CALL_TITLE(value)}
									/>
								</div>
							</div>
							<div className="fo-item fo-m-1-5 req">
								<p className="fo-key">내용</p>
								<div className="fo-value">
									<div className='w100p'>
										<UI.SunEditor
											value={PAY_CALL_CONT}
											valueChanged={(value) => setPAY_CALL_CONT(value)} 
										/>
									</div>	
								</div>
							</div>	
							<div className="fo-item fo-m-1-5">
								<p className="fo-key">첨부파일</p>
								<div className="fo-value">
									<div className='w100p'>
										<UI.FileUpload 
                            				onCreationComplete={onCreationComplete}
                            				onUploadComplete={onUploadComplete}
                            				attrs={{
                                				MaxTotalFileCount: "0",
                                				//ExtensionAllowOrLimit: "0",
                                				Width:"100%",
                                				//ImgPreView: "1",
                                				//Views: "thumbs"
                            				}}
                            			/>
									</div>
								</div>
							</div>
						</div>
					</form>
					<div className="hz-root hz-right hz-gap5 mb10">
						<Button color="pri-o" size="sm" onClick={PayCallFormCheck}>저장</Button>
						<Button color="gray-o" size="sm" onClick={onClickList}>목록</Button>
					</div>					
					
				</main>
			</div>
	        <ModalPopup
	            open={modalIsOpen}
	            title={'noTitle'}
	            size="alert"
	            onClose={() => onClose()}
	        >
	            <div className="modal-con">
	                <p className="msg">
	                    필수 입력이 완료되지 않았습니다.<br/>
	                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;다시 확인해 주세요.
	                </p>
	            </div>
	            <div className="modal-bottom">
	                <Button color='pri' size="md" onClick={() => setmodalIsOpen(false)}>확인</Button>
	            </div>
        	</ModalPopup>			
		</PageContainer>
	);
}
export default ContentsContainer;